import apiService from "@/core/services/apiService";

export type State = { classes: object };
import {Module, VuexModule, Mutation, Action} from "vuex-module-decorators";
import {Actions, Mutations} from "@/store/enums/store.enums";
import {AddressbookActions, AddressbookMutation} from "@/modules/addressbook/store/enums";
import store from "@/store";

@Module
export default class Store extends VuexModule {
    renderKey = 1;
    listParams = {
        page: 1,
        results: 10,
        search: null,
        sort: [],
        filter: {}
    };
    listCache = [];
    listTotal = 0;
    types = [];
    countries = [];

    get getAddressbookRenderKey() {
        return 'addressbook-' + this.renderKey;
    }

    get getAddressbookLastListResult() {
        return this.listCache;
    }

    get getAddressbookLastListTotal() {
        return this.listTotal;
    }

    get getAddressbookTypes() {
        return this.types;
    }

    get getAddressbookCountries() {
        return this.countries;
    }

    @Mutation
    [AddressbookMutation.SET_RENDER_UPDATE]() {
        this.renderKey++;
    }

    @Mutation
    [AddressbookMutation.SET_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.listParams = listParams;
        this.listCache = listCache;
        this.listTotal = listTotal;
    }

    @Mutation
    [AddressbookMutation.SET_TYPES](types) {
        this.types = types;
    }

    @Mutation
    [AddressbookMutation.SET_COUNTRIES](countries) {
        this.countries = countries;
    }

    @Action
    [AddressbookActions.REFRESH_LIST]() {
        this.context.dispatch(AddressbookActions.FETCH_LIST, this.listParams);
    }

    @Action
    [AddressbookActions.FETCH_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("addressbook/list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(AddressbookMutation.SET_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AddressbookActions.GET_ITEM](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`addressbook/get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AddressbookActions.CREATE_ITEM](payload) {

        return new Promise((resolve, reject) => {

            const {data} = payload;

            apiService.post('addressbook/create/', data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(AddressbookMutation.SET_RENDER_UPDATE);
                this.context.dispatch(AddressbookActions.REFRESH_LIST);

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AddressbookActions.UPDATE_ITEM](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data} = payload;

            apiService.put(`addressbook/edit/${editId}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(AddressbookActions.REFRESH_LIST);

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AddressbookActions.DELETE_ITEM](editId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`addressbook/delete/${editId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(AddressbookActions.REFRESH_LIST);

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AddressbookActions.FETCH_TYPES]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("addressbook/list-types/").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(AddressbookMutation.SET_TYPES, data.result);
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AddressbookActions.FETCH_COUNTRIES]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("addressbook/list-countries/").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(AddressbookMutation.SET_COUNTRIES, data.result);
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AddressbookActions.CREATE_TYPE](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('addressbook/create-type/', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(AddressbookActions.FETCH_TYPES);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AddressbookActions.UPDATE_TYPE](payload) {

        return new Promise((resolve, reject) => {

            const {typeId, data: typeData} = payload;

            apiService.put(`addressbook/edit-type/${typeId}`, typeData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(AddressbookActions.FETCH_TYPES);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [AddressbookActions.DELETE_TYPE](typeId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`addressbook/delete-type/${typeId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(AddressbookActions.FETCH_TYPES);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    // ===== Trainer-Partner Actions (courses-module endpoints, exposed in addressbook-store) ===== //

    @Action
    [AddressbookActions.TRAINER_GET_PARTNER](partnerId) {
        return new Promise((resolve, reject) => {
            apiService.get(`courses/partner-get/${partnerId}`).then(({data}) => {
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }
                resolve(data.result);
            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });
        });
    };

    @Action
    [AddressbookActions.TRAINER_GET_PARTNER_BY_ADDRESSBOOK](addressbookId) {
        return new Promise((resolve, reject) => {
            apiService.get(`courses/partner-by-addressbook/${addressbookId}`).then(({data}) => {
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }
                resolve(data.result);
            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });
        });
    };

    @Action
    [AddressbookActions.TRAINER_CREATE_LOGIN](payload) {
        return new Promise((resolve, reject) => {
            const {addressbookId, email} = payload;
            apiService.post(`courses/partner-create-login/${addressbookId}`, {email: email || ''} as any).then(({data}) => {
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }
                resolve(data.result);
            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });
        });
    };

    @Action
    [AddressbookActions.TRAINER_SEND_LOGIN](partnerId) {
        return new Promise((resolve, reject) => {
            apiService.post(`courses/partner-send-login/${partnerId}`, {}).then(({data}) => {
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }
                resolve(data.result);
            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });
        });
    };

    @Action
    [AddressbookActions.TRAINER_DISABLE_LOGIN](partnerId) {
        return new Promise((resolve, reject) => {
            apiService.put(`courses/partner-disable-login/${partnerId}`, {}).then(({data}) => {
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }
                resolve(data.result);
            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });
        });
    };

    @Action
    [AddressbookActions.TRAINER_ENABLE_LOGIN](partnerId) {
        return new Promise((resolve, reject) => {
            apiService.put(`courses/partner-enable-login/${partnerId}`, {}).then(({data}) => {
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }
                resolve(data.result);
            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });
        });
    };

    @Action
    [AddressbookActions.TRAINER_REMOVE_LOGIN](partnerId) {
        return new Promise((resolve, reject) => {
            apiService.delete(`courses/partner-remove-login/${partnerId}`).then(({data}) => {
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }
                resolve(data.result);
            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });
        });
    };

    @Action
    [AddressbookActions.TRAINER_UPDATE_PARTNER](payload) {
        return new Promise((resolve, reject) => {
            const {partnerId, data: partnerData} = payload;
            apiService.put(`courses/partner-update/${partnerId}`, partnerData).then(({data}) => {
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }
                resolve(data.result);
            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });
        });
    };

}
